import { IAddFormDataRows, IDocumentTable } from '@models/Forms/IForms';

export interface IFormDataRowSet {
    /** Ключ набора в таблице: id из конфигурации, без него (или при повторе) — `#<номер>`. */
    key: string;
    config: IAddFormDataRows;
}

/** Наборы добавления строк из FormData: список, а у прежних конфигураций — одиночный addFormDataRows.
 *  Набор без name не работает и в список не входит. */
export const formDataRowSets = (table: IDocumentTable): IFormDataRowSet[] => {
    const configs = table.addFormDataRowsList?.length
        ? table.addFormDataRowsList
        : table.addFormDataRows
          ? [table.addFormDataRows]
          : [];
    const seen = new Set<string>();
    return configs.flatMap((config, index) => {
        if (!config?.name) return [];
        const ownId = config.id && !seen.has(config.id) ? config.id : undefined;
        if (ownId) seen.add(ownId);
        return [{ key: ownId ?? `#${index}`, config }];
    });
};

/** Id действия пустого состояния: `ref="addFormDataRows:<id>"`; прежний `addFormDataRows` — первый доступный набор. */
export const formDataRowSetActionId = (set: IFormDataRowSet) => `addFormDataRows:${set.key}`;

/** Формулы, от которых зависит доступность набора. */
export const formDataRowSetRules = (sets: IFormDataRowSet[]) =>
    sets.flatMap((set) => [set.config.visibilityRules, set.config.addRowButtonRules]);
